import { BaseRouter } from "app/model/common/baseRouter";
import { lazy } from "react";

const RoleGuard = lazy(() => import("app/guard/roleGuard"));

// 수용가 현황
const BaseAllComplex = lazy(() => import("app/pages/admin/allComplex/BaseAllComplex"));
const EngUseStatus = lazy(() => import("app/pages/admin/EngUseStatus"));
const BsnStatus = lazy(() => import("app/pages/admin/bsnStatus/BaseBsnStatus"));
const adminCompanyRouter: BaseRouter[] = [
  // 산단 전체 조회 - 신규
  {path: "/pdcs/allcomplex", element: <RoleGuard><BaseAllComplex /></RoleGuard>},
  // 단지별 조회
  {path: "/pdcs/engusestatus", element: <RoleGuard><EngUseStatus/></RoleGuard>},
  // 사업장 조회 - 전기 사용량
  {path: "/pdcs/bsnstatus", element: <RoleGuard><BsnStatus /></RoleGuard>},
];


// 전력 현황
const Mdb007 = lazy(() => import("app/pages/admin/splyCs/Mdb007"));
const BaseComplexElecStatus = lazy(() => import("app/pages/admin/industrialComplex/electricityUsage/status/Status"));
const HourlyUsage = lazy(() => import("app/pages/admin/industrialComplex/electricityUsage/hourlyUsage/HourlyUsage"));
const AmountUseComplex = lazy(() => import("app/pages/admin/industrialComplex/electricityUsage/amountUseComplex/AmountUseComplex"));
const PricingPlanUseComplex = lazy(() => import("app/pages/admin/industrialComplex/electricityUsage/pricingPlanUseComplex/PricingPlanUseComplex"));
const Renewable = lazy(() => import("app/pages/admin/industrialComplex/electricityUsage/renewable/Renewable"));
const WorkElectricTimeBase = lazy(() => import("app/pages/work/electric/time/WorkElectricTimeBase"));
const WorkElectricBzkndBase = lazy(() => import("app/pages/work/electric/bzknd/WorkElectricBzkndBase"));
const WorkElectricPlanBase = lazy(() => import("app/pages/work/electric/plan/WorkElectricPlanBase"));
const WorkElectricStatBase = lazy(() => import("app/pages/work/electric/stat/WorkElectricStatBase"));
const adminElectricRouter: BaseRouter[] = [
  // 산단 전체 조회
    // 공급/소비량 조회
    {path: "/pdcs/splycs", element: <RoleGuard><Mdb007/></RoleGuard>},

  // 단지별 조회
    // 전력 사용 현황 - 신규 화면
    { path: "/ic/ele/status", element: <RoleGuard><BaseComplexElecStatus /></RoleGuard>},
    // 시간대별 사용량 통계
    { path: "/ic/ele/hourlyUsage", element: <RoleGuard><HourlyUsage /></RoleGuard> },
    // 전력 사용량 통계
    { path: "/ic/ele/amountusecomplex", element: <RoleGuard><AmountUseComplex /></RoleGuard> },
    // 사용 요금제 통계
    { path: "/ic/ele/pricingplan", element: <RoleGuard><PricingPlanUseComplex /></RoleGuard> },
    // 신재생비율/피크저감률 통계
    { path: "/ic/ele/renewable", element: <RoleGuard><Renewable /></RoleGuard> },

  // 업종별 조회
    // 시간대별 사용량 통계
    { path: '/work/electric/time', element: <RoleGuard><WorkElectricTimeBase /></RoleGuard> },
    // 전력 사용량 통계
    { path: '/work/electric/bzknd', element: <RoleGuard><WorkElectricBzkndBase /></RoleGuard> },
    // 사용 요금제 통계
    { path: '/work/electric/plan', element: <RoleGuard><WorkElectricPlanBase /></RoleGuard> },
    // 신재생비율/피크저감률 통계
    { path: '/work/electric/stat', element: <RoleGuard><WorkElectricStatBase /></RoleGuard> },
];


// 신재생 현황
const PwrStationStatus = lazy(() => import("app/pages/admin/pwrStation/PwrStationStatus"));
const SolarPwrGen = lazy(() => import("app/pages/admin/solarPwrGen/SolarPwrGen"));
const EssPwrGen = lazy(() => import("app/pages/admin/ess/EssPwrGen"));
const FacilityStatus = lazy(() => import("app/pages/admin/facility/FacilityStatus"));
const FacilityControl = lazy(() => import("app/pages/admin/facility/FacilityControl"));
const adminRenewRouter: BaseRouter[] = [
  // 산단 전체 조회
    // 발전소 현황
    {path: "/pdcs/pwrstationstatus", element: <RoleGuard><PwrStationStatus/></RoleGuard>},

  // 단지별 조회
    // 발전량 조회
    {path: "/pdcs/solarpwrgen", element: <RoleGuard><SolarPwrGen/></RoleGuard>},
    // ESS 발전량 조회
    {path: "/pdcs/esspwrgen", element: <RoleGuard><EssPwrGen/></RoleGuard>},

  // 사업장 조회
    // 설비 현황
    {path: "/pdcs/facilitystatus", element: <RoleGuard><FacilityStatus/></RoleGuard>},
    // 제어 현황
    {path: "/pdcs/facilitycontrol", element: <RoleGuard><FacilityControl/></RoleGuard>},
];


// 온실가스 현황
const PdcsGasEmsnBase = lazy(() => import("app/pages/admin/gasEmission/PdcsGasEmsnBase"));
const BaseComplexEmissionStatus = lazy(() => import("app/pages/admin/industrialComplex/gasEmissions/status/Status"));
const EmissionsReductionStatistics = lazy(() => import("app/pages/admin/industrialComplex/gasEmissions/emissionsReduction/EmissionsReductionStatistics"));
const EmissionsComplex = lazy(() => import("app/pages/admin/industrialComplex/gasEmissions/emissionsComplex/EmissionsComplex"));
const EmissionsFacility = lazy(() => import("app/pages/admin/industrialComplex/gasEmissions/emissionsFacility/EmissionsFacility"));
const WorkGhgsStatBase = lazy(() => import("app/pages/work/ghgs/stat/WorkGhgsStatBase"));
const WorkGhgsBzkndBase = lazy(() => import("app/pages/work/ghgs/bzknd/WorkGhgsBzkndBase"));
const WorkGhgsFclBase = lazy(() => import("app/pages/work/ghgs/fcl/WorkGhgsFclBase"));
const adminGhgsRouter: BaseRouter[] = [
  // 산단 전체 조회
    // 전력사용 배출량 조회
    {path: "/pdcs/gasemission", element: <RoleGuard><PdcsGasEmsnBase/></RoleGuard>},

  // 단지별 조회
    // 온실가스 배출 현황 - 신규 화면
    {path: "/ic/gas/emissionStatus", element: <RoleGuard><BaseComplexEmissionStatus/></RoleGuard>},
    // 배출량/감축량 통계
    { path: "/ic/gas/erstatistics", element: <RoleGuard><EmissionsReductionStatistics /></RoleGuard> },
    // 배출 업종 통계
    { path: "/ic/gas/emissionsComplex", element: <RoleGuard><EmissionsComplex /></RoleGuard> },
    // 설비별 배출량 비교
    { path: "/ic/gas/emissionsfacility", element: <RoleGuard><EmissionsFacility /></RoleGuard> },

  // 업종별 조회
    // 배출량/감축량 통계
    { path: '/work/ghgs/stat', element: <RoleGuard><WorkGhgsStatBase /></RoleGuard> },
    // 사업장 배출량 통계
    { path: '/work/ghgs/bzknd', element: <RoleGuard><WorkGhgsBzkndBase /></RoleGuard> },
    // 설비 배출량 통계
    { path: '/work/ghgs/fcl', element: <RoleGuard><WorkGhgsFclBase /></RoleGuard> },
];

// 에너지마켓 통계
const ElectricComplexBase = lazy(() => import("app/pages/ot/elecTrade/complex/ElectricComplexBase"));
const ElecCmplxDetailBase = lazy(() => import("app/pages/ot/elecTrade/complex/detail/ElecCmplxDetailBase"));
const ElectricHdBase = lazy(() => import("app/pages/ot/elecTrade/hd/ElectricHdBase"));
const Re100StatusBase = lazy(() => import("app/pages/ot/re100/status/Re100StatusBase"));
const Re100FuflBase = lazy(() => import("app/pages/ot/re100/fufl/Re100FuflBase"));
const PPAMatchingBase = lazy(() => import("app/pages/ot/ppa/matching/PPAMatchingBase"));
const PPACntrBase = lazy(() => import("app/pages/ot/ppa/contract/PPACntrBase"));
const OctStatusBase = lazy(() => import("app/pages/ot/oct/status/OctStatusBase"));
const GhgsStatusBase = lazy(() => import("app/pages/ot/ghgs/status/GhgsStatusBase"));
const adminOtRouter: BaseRouter[] = [
  // 전력거래 실적 > 단지별 거래 현황
  { path: '/ot/electric/complex', element: <RoleGuard><ElectricComplexBase /></RoleGuard> },
  { path: '/ot/electric/complex/detail', element: <RoleGuard><ElecCmplxDetailBase /></RoleGuard> },
  // 전력거래 실적 > 급전시장 운영 실적
  { path: '/ot/electric/hd', element: <RoleGuard><ElectricHdBase /></RoleGuard> },
  // 전력거래 실적 > DC전력거래 운영 실적

  // RE100 실적 > RE100 현황
  { path: '/ot/re100/status', element: <RoleGuard><Re100StatusBase /></RoleGuard> },
  // RE100 실적 > 이행수단별 실적
  { path: '/ot/re100/fufl', element: <RoleGuard><Re100FuflBase /></RoleGuard> },

  // PPA 실적 > PPA 매칭 현황
  { path: '/ot/ppa/matching', element: <RoleGuard><PPAMatchingBase /></RoleGuard> },
  // PPA 실적 > PPA 계약 조회
  { path: '/ot/ppa/contract', element: <RoleGuard><PPACntrBase /></RoleGuard> },

  // 장외거래 실적
  { path: '/ot/oct/status', element: <RoleGuard><OctStatusBase /></RoleGuard> },

  // 온실가스 감축 사업 실적
  { path: '/ot/ghgs/status', element: <RoleGuard><GhgsStatusBase /></RoleGuard> },
];

// 보고서
const ReportAdmin = lazy(() => import("app/pages/report/reportAdmin/ReportAdmin"));
const adminReportRouter: BaseRouter[] = [
  {path: "/report/reportAdmin", element: <RoleGuard><ReportAdmin/></RoleGuard>},
];

// 시스템 관리
const Sys003 = lazy(() => import("app/pages/sys/sys003/Sys003"));
const Sys005 = lazy(() => import("app/pages/sys/sys005/Sys005"));
const Sys008 = lazy(() => import("app/pages/sys/sys008/Sys008"));
const Sys009 = lazy(() => import("app/pages/sys/sys009/Sys009"));
const Sys004 = lazy(() => import("app/pages/sys/sys004/Sys004"));
const Sys007 = lazy(() => import("app/pages/sys/sys007/Sys007"));
const Sys013 = lazy(() => import("app/pages/sys/sys013/Sys013"));
const Sys012 = lazy(() => import("app/pages/sys/sys012/Sys012"));
const Sys006 = lazy(() => import("app/pages/sys/sys006/Sys006"));
const Sys010 = lazy(() => import("app/pages/sys/sys010/Sys010"));
const Sys011 = lazy(() => import("app/pages/sys/sys011/Sys011"));
const Sys014 = lazy(() => import("app/pages/sys/sys014/Sys014"));
const Sys016 = lazy(() => import("app/pages/sys/sys016/Sys016"));
const Sys015 = lazy(() => import("app/pages/sys/sys015/Sys015"));
const SysAlarm = lazy(() => import("app/pages/sys/sysAlarm/SysAlarm"));
const SysUser = lazy(() => import("app/pages/sys/sysUser/mngUser/UserList"));
const SysUserDetail = lazy(() => import("app/pages/sys/sysUser/mngUser/UserDetail"));
const SysMenu = lazy(() => import("app/pages/sys/sysMenu/SysMenu"));
const SysPgm = lazy(() => import("app/pages/sys/sysMenu/SysPgm"));
const SysAcs = lazy(() => import("app/pages/sys/sysInfo/SysAcs"));
const SysStat = lazy(() => import("app/pages/sys/sysInfo/SysStat"));
const SysSplyRsrcBase = lazy(() => import("app/pages/sys/sysSplyRsrc/SysSplyRsrcBase"));
const SysSplyRsrcEtcForm = lazy(() => import("app/pages/sys/sysSplyRsrc/SysSplyRsrcEtcForm"));
const SysSplyRsrcEtcDetail = lazy(() => import("app/pages/sys/sysSplyRsrc/SysSplyRsrcEtcDetail"));
const EeSiteMapAdmin = lazy(() => import("app/pages/sys/eeSiteMap/EeSiteMapAdmin"));
const BillListAdminTax = lazy(() => import("app/pages/cb/billListAdmin/BillListAdminTax"));
const BillListAdminUnpaid = lazy(() => import("app/pages/cb/billListAdmin/BillListAdminUnpaid"));
const VaBase = lazy(() => import("app/pages/cb/vAccount/VaBase"));
const adminSystemRouter: BaseRouter[] = [
  // 빅데이터 관리
  { path: '/sys/bdm', element: <RoleGuard><Sys003 /></RoleGuard> },
  // 빅데이터 관리 > 건물 관리
  { path: '/sys/bdm/building', element: <RoleGuard><Sys005 /></RoleGuard> },
  // 빅데이터 관리 > 수용가별 공정정보 관리
  { path: '/sys/bdm/comProcess', element: <RoleGuard><Sys008 /></RoleGuard> },
  // 빅데이터 관리 > 수용가별 제품정보 관리
  { path: '/sys/bdm/comProduct', element: <RoleGuard><Sys009 /></RoleGuard> },
  // 빅데이터 관리 > 수용가 관리
  { path: '/sys/bdm/consumer', element: <RoleGuard><Sys004 /></RoleGuard> },
  // 빅데이터 관리 > 배출시설 관리
  { path: '/sys/bdm/emissFacility', element: <RoleGuard><Sys007 /></RoleGuard> },
  // 빅데이터 관리 > 에너지 비용 관리
  { path: '/sys/bdm/energyCost', element: <RoleGuard><Sys013 /></RoleGuard> },
  // 빅데이터 관리 > 에너지 사용량 관리
  { path: '/sys/bdm/energyUsa', element: <RoleGuard><Sys012 /></RoleGuard> },
  // 빅데이터 관리 > 설비 관리
  { path: '/sys/bdm/facility', element: <RoleGuard><Sys006 /></RoleGuard> },
  // 빅데이터 관리 > 온실가스 배출량 관리
  { path: '/sys/bdm/gasEmiss', element: <RoleGuard><Sys010 /></RoleGuard> },
  // 빅데이터 관리 > 온실가스 감축량 관리
  { path: '/sys/bdm/gasReduc', element: <RoleGuard><Sys011 /></RoleGuard> },
  // 빅데이터 관리 > 발전설비 운영실적 관리
  { path: '/sys/bdm/genEquipOp', element: <RoleGuard><Sys014 /></RoleGuard> },
  // 빅데이터 관리 > 부하설비 운영실적 관리
  { path: '/sys/bdm/loadEquipOp', element: <RoleGuard><Sys016 /></RoleGuard> },
  // 빅데이터 관리 > 저장설비 운영실적 관리
  { path: '/sys/bdm/stoEquipOp', element: <RoleGuard><Sys015 /></RoleGuard> },

  // 알람관리
  { path: '/sys/sysAlarm', element: <RoleGuard><SysAlarm /></RoleGuard> },

  // 사용자/권한 관리
  { path: '/sys/userMng', element: <RoleGuard><SysUser /></RoleGuard> },
  { path: '/sys/userMng/detail', element: <RoleGuard><SysUserDetail /></RoleGuard>},

  // 메뉴/프로그램 관리
  { path: '/sys/sysMenu', element: <RoleGuard><SysMenu /></RoleGuard> },
  { path: '/sys/sysPgm', element: <RoleGuard><SysPgm /></RoleGuard> },

  // RE100/탄소 정보 관리
  { path: '/sys/rc/splyRsrc', element: <RoleGuard><SysSplyRsrcBase /></RoleGuard>},
  { path: '/sys/rc/splyRsrc/form', element: <RoleGuard><SysSplyRsrcEtcForm /></RoleGuard>},
  { path: '/sys/rc/splyRsrc/detail', element: <RoleGuard><SysSplyRsrcEtcDetail /></RoleGuard>},
  { path: '/sys/ee/site-map', element: <RoleGuard><EeSiteMapAdmin /></RoleGuard>},

  // 시스템 정보 관리
  { path: '/sys/info/sysAcs', element: <RoleGuard><SysAcs /></RoleGuard> },
  { path: '/sys/info/sysStat', element: <RoleGuard><SysStat /></RoleGuard> },

  // 정산 관리
  { path: "/sys/bill/va", element: <RoleGuard><VaBase /></RoleGuard> },
  { path: "/sys/bill/unpaid", element: <RoleGuard><BillListAdminUnpaid /></RoleGuard> },
  { path: "/sys/bill/tax", element: <RoleGuard><BillListAdminTax /></RoleGuard> },
];

export const adminRouter: BaseRouter[] = [
  ...adminCompanyRouter,
  ...adminElectricRouter,
  ...adminRenewRouter,
  ...adminGhgsRouter,
  ...adminOtRouter,
  ...adminReportRouter,
  ...adminSystemRouter,
];

